import { render, staticRenderFns } from "./tCO2.vue?vue&type=template&id=5e055363&scoped=true"
import script from "./tCO2.vue?vue&type=script&lang=js"
export * from "./tCO2.vue?vue&type=script&lang=js"
import style0 from "./tCO2.vue?vue&type=style&index=0&id=5e055363&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e055363",
  null
  
)

export default component.exports